import {
  initialState,
  Actions,
  State,
  GET_UNREAD_COUNT,
  GET_UNREAD_COUNT_SUCCESS,
  GET_UNREAD_COUNT_ERROR,
} from '../../types/in-app-notification/get-unread-count';
import { MARK_NOTIFICATION_READ_SUCCESS } from '../../types/in-app-notification/mark-as-read';
import { MARK_ALL_NOTIFICATIONS_READ_SUCCESS } from '../../types/in-app-notification/mark-all-as-read';

type ExtendedActions = Actions | { type: typeof MARK_NOTIFICATION_READ_SUCCESS; payload: any } | { type: typeof MARK_ALL_NOTIFICATIONS_READ_SUCCESS; payload: any };

const reducers = (state = initialState, action: ExtendedActions): State => {
  switch (action.type) {
    case GET_UNREAD_COUNT:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        data: action.payload as number,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_UNREAD_COUNT_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload as string | boolean,
          success: false,
        },
      };
    case MARK_NOTIFICATION_READ_SUCCESS:
      return {
        ...state,
        data: Math.max(0, state.data - 1),
      };
    case MARK_ALL_NOTIFICATIONS_READ_SUCCESS:
      return {
        ...state,
        data: 0,
      };
    default:
      return state;
  }
};

export default reducers;
